










import Vue from 'vue';
import numberWithCommas from '../../utils/numberWithCommas'

export default Vue.extend({
  name: 'Bidding',
  props: [
    'bidding',
  ],
  computed: {
    // bidding: string = "닉네임;응찰가격;응찰시간"
    biddingSplit () {
      if (this.bidding == undefined) return [];
      return this.bidding.split(';')
    }
  },
  filters: {
    comma (val: number | string): string {
      return numberWithCommas(Number(val));
    }
  }
});
